module.exports = __webpack_public_path__ + "static/media/evnt-tick.bce819d3.svg";